import { createTheme } from '@mui/material'

import theme from 'utils/theme'

export const materialTheme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: theme.colors.muiLabel
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: theme.colors.outlinedBorder
        }
      }
    }
  },
  typography: {
    h4: {
      fontFamily: 'Raleway, sans-serif',
      fontSize: 28
    },
    h5: {
      fontFamily: 'Raleway, sans-serif',
      fontSize: 24,
      color: theme.colors.addProductSectionTitle,
      width: 'fit-content'
    }
  },
  palette: {
    primary: {
      main: theme.colors.primary,
      light: theme.colors.secondary
    },
    secondary: {
      main: theme.colors.secondary
    },
    text: {
      secondary: 'rgba(0,0,0,0.6)',
      disabled: 'rgba(0,0,0,0.12)'
    }
  }
})
